// src/components/Home/HomeSlider.jsx
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import SliderSkeleton from "./SliderSkeleton";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HomeSlider = React.memo(({ sliderData }) => {
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen width for mobile/desktop image switching
  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768); // Mobile breakpoint
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2800,
    arrows: false,
  };

  // Skeleton while loading
  if (!sliderData || sliderData.length === 0) {
    return <SliderSkeleton />;
  }

  return (
    <div className="home-page-slider">
      <Slider {...settings}>
        {sliderData.map((item, index) => {
          // Correct image selection based on device
          const imageUrl = isMobile
            ? item.mobile_image_url
            : item.slider_image_url;

          return (
            <div key={item.id} className="slider-item">
              <Link to="/shop">
                <div className="slider-content">
                  <img
                    src={imageUrl}
                    alt={item.alt_text ?? "Slider Image"}
                    loading={index === 0 ? "eager" : "lazy"}
                    className="slick-image w-full h-auto object-cover"
                  />
                </div>
              </Link>
            </div>
          );
        })}
      </Slider>
    </div>
  );
});

export default HomeSlider;
